import * as THREE from 'three'
import { Helper } from '../../../../classes/helper'
import { useMeasures } from '../../../../hooks/state/useMeasures'
import { Suspense } from 'react'
import { Marquee } from './Marquee'
import { useVerandaSelector } from '../../../..'
import { MarqueeIntegrate } from './MarqueeIntegrate'
import { useMarquee } from '../../../../hooks/state/useMarquee'
import { Farbric } from './Farbric'
import { Plissee } from './Plissee'

export const Shading = (): JSX.Element => {
  const { userWidth, roofLogWidth, polesTopNumber, isQubus, verandaLogWidth } =
    useMeasures()

  const { getMarqueePosition, marqueeTyp, checkMarqueeAmount, marqueeStack } =
    useMarquee()
  const poles = polesTopNumber - 1 > 0 ? polesTopNumber - 1 : 2
  const nightMode = useVerandaSelector((state) => state.scene.nightMode)
  checkMarqueeAmount()
  const space = !isQubus ? userWidth : userWidth - verandaLogWidth
  return (
    <group position={[0, 0, 0.015]}>
      {(marqueeTyp.hasUnderRoof || marqueeTyp.hasOverRoof) && (
        <Suspense fallback={null}>
          <group
            position={[marqueeTyp.hasUnderRoof ? space / 2 : -space / 2, 0, 0]}
            rotation={[
              0,
              Helper.convertAngleToRadiant(marqueeTyp.hasOverRoof ? 90 : -90),
              Helper.convertAngleToRadiant(marqueeTyp.hasOverRoof ? 0 : 180),
            ]}
            key={`RoofMarquee`}
          >
            {marqueeStack.map((width, index) => {
              return (
                <Marquee
                  marqueeWidth={width}
                  marqueePosition={getMarqueePosition(index, width)}
                  key={`RoofMarquee${index}`}
                />
              )
            })}
          </group>
        </Suspense>
      )}

      {marqueeTyp.hasIntergrateBox && (
        <Suspense fallback={null}>
          <MarqueeIntegrate name={`MarqueeIntegrate`} />
        </Suspense>
      )}

      {(marqueeTyp.haslPlissee || marqueeTyp.haslFabric) &&
        [...Array(poles)].map((_, index) => {
          return (
            <group key={`Poles${index}`}>
              {marqueeTyp.haslPlissee && (
                <Suspense fallback={null}>
                  <Plissee positionX={index} />
                </Suspense>
              )}
              {marqueeTyp.haslFabric && (
                <Suspense fallback={null}>
                  <Farbric positionX={index} />
                </Suspense>
              )}
            </group>
          )
        })}

      {!marqueeTyp.hasNotShading && !nightMode && (
        <group rotation={[0, 0, THREE.MathUtils.degToRad(-180)]}>
          <rectAreaLight
            position={[0, -0.04, roofLogWidth / 2]}
            width={userWidth - 0.15}
            height={roofLogWidth}
            color={'white'}
            intensity={nightMode ? 0 : 0.6}
            rotation={[-Math.PI / 2, 0, 0]}
          ></rectAreaLight>
        </group>
      )}
    </group>
  )
}
